import * as React from "react";
import CurrencyFormat from "react-currency-format";
var onValueChange = function (values, callback) {
    var value = values.value === "-" ? undefined : values.value;
    return !!callback ? callback(value) : undefined;
};
/**
 *
 * @param props
 */
export var CurrencyInput = function (props) {
    var onChangeValue = function (values) {
        onValueChange(values, props.onChange);
    };
    return (props.withPrefix ? (React.createElement(CurrencyFormat, { value: props.amount, thousandSeparator: ".", decimalSeparator: ",", displayType: !!props.isInput ? "input" : "text", className: props.className, decimalScale: props.withoutDecimal ? 0 : 2, prefix: "€\xa0", fixedDecimalScale: true, allowNegative: false, onValueChange: onChangeValue, placeholder: props.placeholder, disabled: props.disabled })) : (React.createElement(CurrencyFormat, { value: props.amount, thousandSeparator: ".", decimalSeparator: ",", displayType: !!props.isInput ? "input" : "text", className: props.className, decimalScale: props.withoutDecimal ? 0 : 2, fixedDecimalScale: true, allowNegative: true, onValueChange: onChangeValue, placeholder: props.placeholder, disabled: props.disabled })));
};
export var testUtil = {
    onValueChange: onValueChange,
};
